import React, { memo, useMemo, useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import { translate } from '../../utils/language';
import SecondaryButton from '../../components/ui/SecondaryButton';
import { useNavigate } from 'react-router-dom';

function ThemesIntegrationModal({ setOpen }: { setOpen: Function }) {

  const navigate = useNavigate()
  return (
    <>
      <div className={`appear fixed inset-0 overflow-y-visible flex flex-col p-5 items-center top-0 left-0 z-[100]`}>
        <div className='shadow' ></div>
        <div className="bg-white p-8 w-[90%] md:w-[60%] xl:w-[600px] z-[500] overflow-visible h-auto m-auto rounded-2xl">

          <div className='pb-2 my-2 flex items-center flex-col gap-[10px]'>
            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
              <path d="M30.419 16.6843C30.5143 13.8343 29.7496 11.0215 28.2245 8.61179C26.6993 6.20205 24.4842 4.30681 21.8672 3.17252C19.2502 2.03823 16.3523 1.71736 13.5505 2.25164C10.7486 2.78592 8.17234 4.15062 6.15668 6.1683C4.14102 8.18598 2.77922 10.7633 2.24835 13.5651C1.71748 16.3669 2.0421 19.2636 3.18 21.8784C4.3179 24.4933 6.21644 26.7054 8.62875 28.2272C11.0411 29.7489 13.8555 30.5098 16.7062 30.4109" stroke="#5E5873" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M16.207 8.31616V16.2105L19.3656 19.3682" stroke="#5E5873" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="27.5" cy="27.5005" r="6.5" fill="#E23D47" />
              <path d="M27.5 24V28" stroke="white" stroke-width="2" stroke-linecap="round" />
              <path d="M27.5 31V31.001" stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>
            <span >Entegrasyon Gerekiyor</span>
            <span className="!text-start w-full flex justify-center text-normal text-[15px] ">Yeni tema ekleyebilmek için entegrasyon yapmanız gerekiyor.</span>

          </div>
          <div className='flex flex-row pt-1 justify-center gap-[15px]' >
            <SecondaryButton value={"Kapat"} onClick={() => { setOpen(false) }} />
            <PrimaryButton value={"Entegrasyon Yap"} onClick={() => { navigate("/dashboard/theme-settings/integrations/provider") }} ></PrimaryButton>
            {/* {error && <div className='ml-auto pr-3 flex items-center text-red-500' >
              {translate(error)}
            </div>} */}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(ThemesIntegrationModal);
